import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ScrollIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "50",
                cy: "50",
                r: "50",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M50.7071 33.2929C50.3166 32.9024 49.6834 32.9024 49.2929 33.2929L42.9289 39.6569C42.5384 40.0474 42.5384 40.6805 42.9289 41.0711C43.3195 41.4616 43.9526 41.4616 44.3431 41.0711L50 35.4142L55.6569 41.0711C56.0474 41.4616 56.6805 41.4616 57.0711 41.0711C57.4616 40.6805 57.4616 40.0474 57.0711 39.6569L50.7071 33.2929ZM51 72L51 34L49 34L49 72L51 72Z",
                fill: "white"
            })
        ]
    });
